module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('UserProfile', {

		configure: function (options) {
            var userData = fox.wom.selectFirst('~.PermissionManager').getMemberInfo();
			
			this.registerOptions('', {
				autoRender: true,
				'embed.container': '#user-profile',
                template: 'user_profile',
                templateOptions: userData
			});

			this.callParent('configure', arguments);
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-profile/widget/userProfile.js
// module id = 562
// module chunks = 4